import { c as _c } from "react/compiler-runtime";
import * as Headless from '@headlessui/react';
import NextLink, { type LinkProps } from 'next/link';
import React, { forwardRef } from 'react';
export const Link = forwardRef(function Link(props, ref) {
  const $ = _c(3);
  let t0;
  if ($[0] !== props || $[1] !== ref) {
    t0 = <Headless.DataInteractive><NextLink {...props} ref={ref} /></Headless.DataInteractive>;
    $[0] = props;
    $[1] = ref;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
});